import React, { useState, useEffect, useRef } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
// API-Service
import { getVoucherList, voucherListService } from "../../../service/voucher.service";
import { applyVoucherService } from "../../../service/cart.service";

// Redux-Settings
import {
  selectCartList,
  selectSelectedCartItemsList,
  selectShipingCost,
  selectSubtotalAmount,
  setDiscountAmount,
  setIsAppliedVoucher,
  setVoucherContent,
  setVoucherDiscountAmount,
  selectCartVendorList,
  selectSelfPickup,
  selectDiscountAmount
} from "../../../redux/cartSlice";

// Components
import ShowMoreLessText from "../../micro/ShowMoreLessText/ShowMoreLessText";
import "../../../assets/scss/base/pages/account/Voucher.scss";

// Images
import VoucherNotFoundIcon from "../../../assets/images/homepage/voucher-not-found.svg";
import VoucherBackground from "../../../assets/images/homepage/Voucher-BG.svg";
import VoucherModalCard from "../../account/ModalCardForVoucher";

function VouchersModal({ voucherModaltoggle, isOpenVoucherModal }) {
  const selectedCartItems = useSelector(selectSelectedCartItemsList);
  const subtotalAmount = useSelector(selectSubtotalAmount);
  const shipingCost = useSelector(selectShipingCost);
  const cartItems = useSelector(selectCartList);
  const cartVendorItems = useSelector(selectCartVendorList);
  const isSelfPickup = useSelector(selectSelfPickup);
  const [applyingId, setApplyingId] = useState(null);
  const dispatch = useDispatch();
  const [isLoading, setIsloading] = useState(true);
  const [voucherList, setVoucherList] = useState([]);
  const discountAmount = useSelector(selectDiscountAmount);

  const selectedVendor = cartVendorItems?.find(vendorItem =>
    vendorItem?.items?.some(product =>
      selectedCartItems?.some(cartItem => cartItem?.id === product?.id)
    )
  );

  const productIDs = selectedVendor?.items
    ?.filter(product =>
      selectedCartItems?.some(cartItem => cartItem?.id === product?.id)
    )
    ?.map(product => product.productId) || [];

  const selectedVendorId = selectedVendor?.vendor?.id;
  const vendorIds = selectedVendorId

  // Fetch Voucher List
  const fetchList = async () => {
    setIsloading(true);
    const response = await getVoucherList({
      page:1,
      amount: subtotalAmount,
      productIds: productIDs,
      vendorId: vendorIds,
      type: "claimed"

    });
    if (response?.data?.success) {
      setIsloading(false);
      setVoucherList(response?.data?.data?.list);
    }
  };

  useEffect(() => {
    fetchList();
  }, []);


  // // Modal-Controll
  // const [formValue, setFormValue] = useState({});
  // const [isOpenVoucherApplyConfirmModal, setIsOpenVoucherApplyConfirmModal] = useState(false);
  // const voucherApplyConfirmToggle = () => setIsOpenVoucherApplyConfirmModal(!isOpenVoucherApplyConfirmModal);

  const closeBtn = (
    <button className="close" onClick={voucherModaltoggle} type="button">
      &times;
    </button>
  );

  const handleApplyVoucher = async ({ voucherItem }) => {
    setApplyingId(voucherItem?.id); // start loader on this voucher

    const response = await applyVoucherService({
      shippingCost: shipingCost,
      cartItemsId: selectedCartItems?.map((cartItem) => cartItem?.id),
      code: voucherItem?.Voucher?.code,
      amount: subtotalAmount,
      vendorId: vendorIds
    });

    if (response?.data?.success) {

      const voucherDiscount = response?.data?.data || 0;

      //  total after voucher
      const totalAfterVoucher =
        subtotalAmount - (voucherDiscount + discountAmount);

      //  block negative / zero total
      if (totalAfterVoucher < 0) {
        toast.error(
          "Voucher cannot be applied as total amount becomes zero or negative"
        );
        setApplyingId(null);
        return;
      }

      dispatch(setVoucherDiscountAmount(response?.data?.data));
      dispatch(setDiscountAmount(response?.data?.data));
      dispatch(setVoucherContent(voucherItem?.Voucher));
      dispatch(setIsAppliedVoucher(true));

      toast.success("Voucher applied successfully!");

      // CLOSE MODAL AFTER SUCCESS
      setTimeout(() => {
        voucherModaltoggle();
      }, 300); // slight delay for UI smoothness
    } else {
      console.error("Voucher apply error:", response);
      toast.error(response?.data?.errorMessage || "Voucher can't be applied");
    }

    setApplyingId(null);
  };

  const getSellerDisplay = (voucher) => {
    if (voucher?.forAllVendors) {
      return "Pineapple.my";
    }

    if (Array.isArray(voucher?.vendors) && voucher.vendors.length > 0) {
      return voucher.vendors
        .map(vendor => vendor.companyName)
        .join(", ");
    }

    return "N/A";
  };


  return (
    <div>
      <Modal
        className="addrees__modal voucher__modal__block big__modal"
        modalClassName="left__modal"
        backdropClassName="light__modal__background"
        isOpen={isOpenVoucherModal}
        toggle={voucherModaltoggle}
        fullscreen
      >
        <ModalHeader toggle={voucherModaltoggle} close={closeBtn}>
          Your Claimed  Vouchers
        </ModalHeader>
        <ModalBody>
          {!isLoading ? (
            <>
              {voucherList?.length > 0 ? (
                <>
                  {voucherList.map((voucherItem) => (
                    <div className="voucher-list-wrapper-modal" key={voucherItem?.id} >
                      <VoucherModalCard
                        key={voucherItem?.id}
                        voucher={voucherItem}
                        isApplying={applyingId === voucherItem?.id}
                        onApply={(item) =>
                          handleApplyVoucher({ voucherItem: item })
                        }
                      />
                    </div>
                  ))}
                </>
              ) : (
                <div className="voucher__item__notfound__block">
                  <img src={VoucherNotFoundIcon} alt="" />
                  <div>
                    <h3>No Voucher found</h3>
                    <p>You don’t have any vouchers at this moment</p>
                  </div>
                  <button
                    className="voucher__item__back__btn"
                    onClick={voucherModaltoggle}
                  >
                    Back
                  </button>
                </div>
              )}
            </>
          ) : (
            <>
              {[1, 2, 3]?.map((placeHolderItem) => (
                <div key={placeHolderItem} className="voucher__item">
                  <Skeleton height={50} />
                  <Skeleton height={30} />
                  <Skeleton count={2} height={20} />
                </div>
              ))}
            </>
          )}
        </ModalBody>
        {/* {voucherList?.length > 0 && (
          <ModalFooter>
            <button
              className="voucher__item__back__btn"
              onClick={voucherModaltoggle}
            >
              Back
            </button>
          </ModalFooter>
        )} */}
      </Modal>

      <Toaster position="top-right" />
    </div>
  );
}

export default VouchersModal;
